const EDUCATION_INDUSTRY_ID = 1;
const VIDEO_PRODUCTION_INDUSTRY_ID = 4;
const ACADEMY_INDUSTRY_ID = 5;

//test

export const coreDrawers = (industryId?: number) => {
  const base = [
    { label: "Overview", value: "Overview" },
    { label: "Followups", value: "Followups" },
    { label: "Deadlines", value: "Deadlines" },
    { label: "Attachment", value: "Attachment" },
  ];

  if (industryId === EDUCATION_INDUSTRY_ID) {
    base.push(
      { label: "Portal", value: "Portal" },
      { label: "Fees", value: "Fees" },
      { label: "Payments", value: "Payments" }
    );
  }

  if (
    industryId === VIDEO_PRODUCTION_INDUSTRY_ID ||
    industryId === ACADEMY_INDUSTRY_ID
  ) {
    base.push({ label: "Payments", value: "Payments" });
  }

  return base;
};

export const nichDrawer = (industry: number = 1) => {
  switch (industry) {
    case 1:
      return [
        { label: "Qualification", value: "Qualification" },
        { label: "Course", value: "Course" },
      ];
    case 4:
      return [{ label: "Service", value: "Service" }];
    case 5:
      return [
        { label: "Qualification", value: "Qualification" },
        { label: "Program", value: "Program" },
      ];
    default:
      return [];
  }
};

export const dynamicDrawer = (stages: any[] = []) => {
  const routes = stages
    .filter((val) => val.isShowInLeadProfile)
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
    .map((val) => ({
      label: val.name,
      value: val.name,
      id: val.id,
      type: "stage",
      identifier: val.unique_identifier,
    }));
  return routes;
};

export const logsDrawer = () => [
  { label: "Chat", value: "Chat" },
  { label: "Activity Log", value: "Activity Log" },
  { label: "Call History", value: "Call History" },
  { label: "Tracks", value: "Tracks" },
];

export const getAllDrawers = (industry: number, stages?: any[]) => {
  return [
    ...coreDrawers(industry),
    ...nichDrawer(industry),
    ...dynamicDrawer(stages),
    ...logsDrawer(),
  ];
};
